import React from "react";
import logo from "../assets/image.jpg";
import "../styles/footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="app-footer">
      <div className="footer-left">
        <p>
          © <span className="footer-year">{currentYear}  SFW Technologies India Pvt Ltd. All rights reserved.</span>
        </p>
      </div>
      <div className="footer-right">
        <span className="powered-by">Powered by</span>
        <img src={logo} alt="SFW Logo" className="footer-logo" />
      </div>
    </footer>
  );
};

export default Footer;
